import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Archive, Pencil, RotateCcw } from "lucide-react";

const id = (k) => k.replace(/\s/g, "-");

/* One role: its name, who holds it, and what can be done to it. */
export function RoleRow({ r, busy, onRename, onAct }) {
  const held = r.holders > 0;
  return (
    <div data-testid={`role-row-${id(r.key)}`} className={`py-2 flex flex-wrap items-center gap-2 ${r.retired ? "opacity-70" : ""}`}>
      <div className="min-w-0 mr-auto">
        <span data-testid={`role-name-${id(r.key)}`} className="font-semibold text-[#1F1F1F]">{r.name}</span>
        {r.name !== r.key && <span className="ml-1 text-[11px] text-slate-400 font-mono">({r.key})</span>}
        {r.builtin && <Badge className="ml-2 rounded bg-slate-100 text-slate-600 text-[10px] hover:bg-slate-100">Built in</Badge>}
        {r.retired && <Badge data-testid={`role-retired-${id(r.key)}`} className="ml-2 rounded bg-amber-100 text-amber-800 text-[10px] hover:bg-amber-100">Retired</Badge>}
        <span data-testid={`role-people-${id(r.key)}`} className="block text-[12px] text-slate-500">
          {r.admin ? "Superuser — always everything, can't be toggled, renamed or retired" : `${r.people} active ${r.people === 1 ? "person" : "people"}`}
          {!r.admin && r.holders > r.people && ` · ${r.holders - r.people} deactivated or archived`}
        </span>
      </div>
      {!r.admin && (
        <div className="flex gap-1.5">
          <Button data-testid={`role-rename-${id(r.key)}`} size="sm" variant="outline" disabled={busy} onClick={onRename}>
            <Pencil className="w-3.5 h-3.5 mr-1" /> Rename
          </Button>
          {r.retired
            ? <Button data-testid={`role-restore-${id(r.key)}`} size="sm" variant="outline" disabled={busy} onClick={() => onAct(r, "restore")}>
                <RotateCcw className="w-3.5 h-3.5 mr-1" /> Restore
              </Button>
            : <Button data-testid={`role-retire-${id(r.key)}`} size="sm" variant="outline" disabled={busy || held}
                title={held ? "Move everyone out of this role first — deactivated and archived accounts count too" : "Retire — never deleted, can be restored"}
                onClick={() => onAct(r, "retire")}>
                <Archive className="w-3.5 h-3.5 mr-1" /> Retire
              </Button>}
        </div>
      )}
    </div>
  );
}
